import { Component, OnInit } from '@angular/core';
import { ReporteService } from '../reporte.service';
import { LoginService } from '../../../login/login.service';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  templateUrl: './reporte-ctb-cta.component.html',
  styleUrls: ['./reporte-ctb-cta.component.css'],
  preserveWhitespaces: true,
  providers: [ReporteService]
})
export class ReporteCtbCtaComponent implements OnInit {
  items: any[] = [];
  reporte: any[];
  tipoCuenta: any[];
  criteriaSearch: any;
  iniResult = 0; 
  maxResults = 50;
  registros = 100;
  aumento = 50;
  actualizar = false;
  empresa: any;
  cargado: boolean;
  alerta_agrupador_sat = false;
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private reporteService: ReporteService, private loginService: LoginService) {
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.cargarEmpresa();
    this.cargarTiposCuenta();
    this.criteriaSearch = {};
    this.criteriaSearch['ini'] = this.iniResult;
    this.criteriaSearch['fin'] = this.maxResults;
    
  }
  buscarEnCatalogo(): void {
    this.criteriaSearch['ini'] = 0;
    this.maxResults = 50;
    this.criteriaSearch['fin'] = this.maxResults;
    this.cargarCatalogo();
    this.items = [];
  }
  cargarTiposCuenta() {
      this.tipoCuenta = [''];
  } 
  cargarEmpresa() {
        this.empresa = this.loginService.usuario.empresa_seleccionada.titulo;
    
  }
  onWheel(event: WheelEvent) {
  const container = event.currentTarget as HTMLElement;
  container.scrollTop += event.deltaY; // scroll vertical
  // Si quieres scroll horizontal con Shift presionado:
  if (event.shiftKey) {
    container.scrollLeft += event.deltaY;
  }
  event.preventDefault(); // evita que el scroll se propague
}
  cargarCatalogo() {
    this.actualizar = false;
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.reporteService.getRepCtbCta(this.loginService.empresa, 0).subscribe(response => {
      this.items = [];
      for (const item of response.contenido) {
        this.items.push(item);
        if (this.items[this.items.length - 1].nivel_arbol === 0) {
          this.items[this.items.length - 1].codigo = this.items[this.items.length - 1].codigo.toUpperCase();
          this.items[this.items.length - 1].nombre = this.items[this.items.length - 1].nombre.toUpperCase();
            this.items[this.items.length - 1].tipo = this.items[this.items.length - 1].tipo.toUpperCase();
            this.items[this.items.length - 1].naturaleza = this.items[this.items.length - 1].naturaleza.toUpperCase()

        }
        for (let x = 0; x < this.items[this.items.length - 1].nivel_arbol ; x++) {
          this.items[this.items.length - 1].codigo = '-- ' + this.items[this.items.length - 1].codigo;
          this.items[this.items.length - 1].nombre = '-- ' + this.items[this.items.length - 1].nombre;
        }
      }
      this.cerrarMensajeCarga();
      if (response.tipo_mensaje === 'Alert' && this.alerta_agrupador_sat === false) {
        this.alerta_agrupador_sat = true;
      this.showNotification(response.mensaje)
      }
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }

  showNotification(mensaje: any) {
    const color = 'danger';
    $.notify({
      icon: 'pe-7s-info',
      message: mensaje
    }, {
        type: color,
        timer: 1000,
        placement: {
          from: 'top',
          align: 'center'
        }
      });
  }
  

  filtroDeBusqueda(find: any, columnName: any): void {
    this.criteriaSearch[columnName] = find;
  }
  limpiarBusqueda(): void {
    this.criteriaSearch = {};
    this.cargarCatalogo();
  }
  exportAsXLSX(): void {
  // Preparar los datos para Excel (array de arrays)
  const data: any[][] = [
    ['Nivel', 'Padre', 'Cuenta', 'Nombre', 'Moneda', 'Tipo', 'Naturaleza', 'Agrupador SAT']
  ];

  this.items.forEach(item => {
    data.push([
      item.nivel_arbol + 1,
      item.codigoPadre,
      item.codigo,
      item.nombre,
      item.moneda,
      item.tipo,
      item.naturaleza,
      item.agrupadorSat
    ]);
  });

  // Crear libro y hoja
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);

  // Ajustar anchos de columna (opcional)
  const colWidths = [
    { wch: 8 },  // Nivel
    { wch: 12 }, // Padre
    { wch: 15 }, // Cuenta
    { wch: 40 }, // Nombre
    { wch: 12 }, // Moneda
    { wch: 15 }, // Tipo
    { wch: 15 }, // Naturaleza
    { wch: 20 }  // Agrupador SAT
  ];
  ws['!cols'] = colWidths;

  // Agregar la hoja al libro
  XLSX.utils.book_append_sheet(wb, ws, 'Cuentas');

  // Generar archivo y descargar
  XLSX.writeFile(wb, this.empresa.toLowerCase() + '_reporte_cuentas.xlsx');
}
  exportAsPDF(): void {
  const doc = new jsPDF('landscape', 'mm', 'a4'); // Horizontal para más columnas
  const pageWidth = doc.internal.pageSize.getWidth();

  // Título
  doc.setFontSize(16);
  doc.text( this.empresa + ": Árbol de Cuentas", pageWidth / 2, 15, { align: 'center' });

  // Configurar la tabla
  autoTable(doc, {
    startY: 25,
    head: [['Nivel', 'Padre', 'Cuenta', 'Nombre', 'Moneda', 'Tipo', 'Naturaleza', 'Agrupador SAT']],
    body: this.items.map(item => [
      item.nivel_arbol + 1,
      item.codigoPadre,
      item.codigo,
      item.nombre,
      item.moneda,
      item.tipo,
      item.naturaleza,
      item.agrupadorSat
    ]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: 'linebreak'
    },
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { cellWidth: 12, halign: 'center' },  // Nivel
      1: { cellWidth: 20, halign: 'center' },  // Padre
      2: { cellWidth: 25, halign: 'center' },  // Cuenta
      3: { cellWidth: 'auto' },                // Nombre (ocupa el resto)
      4: { cellWidth: 18, halign: 'center' },  // Moneda
      5: { cellWidth: 22, halign: 'center' },  // Tipo
      6: { cellWidth: 22, halign: 'center' },  // Naturaleza
      7: { cellWidth: 28, halign: 'center' }   // Agrupador SAT
    },
    didDrawPage: (data) => {
      // Pie de página opcional
      const pageCount = (doc as any).internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(`Página ${data.pageNumber} de ${pageCount}`, pageWidth - 20, doc.internal.pageSize.getHeight() - 5);
    }
  });

  // Guardar el PDF
  doc.save(this.empresa.toLowerCase() + '_reporte_cuentas.pdf');
}
  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  abrirCuenta(id: number) {
    this.actualizar = true;
  const params = new URLSearchParams();
params.set('sinMenu', 'true');
  const url = `/#/contabilidad/catalogo/ctb-cta/actualizar/${id}?${params.toString()}`;

  const width = window.screen.width * 0.8;   // ancho de la ventana (50%)
const height = window.screen.height * 0.8; // alto de la ventana (50%)

// Calculamos la posición centrada
const left = (window.screen.width - width) / 2;
const top = (window.screen.height - height) / 2;

const ventana = window.open(
  url,
  'VisualizarCuenta',
  `top=${top},left=${left},width=${width},height=${height},resizable=yes,scrollbars=yes`
);
}
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
